var _rect, _circle, _circle2, _path, _path2, _circle3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle4, _path27, _path28, _path29, _path30, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFramedPicture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 22,
    height: 22,
    fill: "url(#paint0_linear_715_15777)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.1869,
    cy: 12.1266,
    r: 2.06773,
    fill: "url(#paint1_radial_715_15777)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.1869,
    cy: 12.1266,
    r: 2.06773,
    fill: "url(#paint2_radial_715_15777)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2676 12.9869C24.3301 10.5398 26.1822 9.32772 27.0005 9.15332V14.7075H24.6863L23.2676 12.9869Z",
    fill: "url(#paint3_radial_715_15777)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2676 12.9869C24.3301 10.5398 26.1822 9.32772 27.0005 9.15332V14.7075H24.6863L23.2676 12.9869Z",
    fill: "url(#paint4_radial_715_15777)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3069,
    cy: 14.7334,
    r: 3.24443,
    fill: "url(#paint5_radial_715_15777)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5L2 2V30L5 27V5Z",
    fill: "url(#paint6_linear_715_15777)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5L2 2V30L5 27V5Z",
    fill: "url(#paint7_linear_715_15777)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 27L2 30L30 30L27 27H5Z",
    fill: "url(#paint8_linear_715_15777)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 27L2 30L30 30L27 27H5Z",
    fill: "url(#paint9_linear_715_15777)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5 27L2 30L30 30L27 27H5Z",
    fill: "url(#paint10_linear_715_15777)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27L30 30L30 2L27 5V27Z",
    fill: "url(#paint11_linear_715_15777)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27L30 30L30 2L27 5V27Z",
    fill: "url(#paint12_linear_715_15777)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27 5H5L2 2H30L27 5Z",
    fill: "url(#paint13_linear_715_15777)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27 5H5L2 2H30L27 5Z",
    fill: "url(#paint14_linear_715_15777)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27 5H5L2 2H30L27 5Z",
    fill: "url(#paint15_linear_715_15777)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_715_15777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.51073 17.808L5 19.2487V27H27V12.2393C25.5 12.2393 24.5 12.7313 23 14.2074L18.5 18.6356C17.5 19.6197 16.5724 19.9998 15.5724 19.5077C15.2391 19.3437 14.0345 18.5796 12.529 17.727C10.9774 16.8483 8.62771 17.1119 7.51073 17.808Z",
    fill: "url(#paint16_radial_715_15777)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51073 17.808L5 19.2487V27H27V12.2393C25.5 12.2393 24.5 12.7313 23 14.2074L18.5 18.6356C17.5 19.6197 16.5724 19.9998 15.5724 19.5077C15.2391 19.3437 14.0345 18.5796 12.529 17.727C10.9774 16.8483 8.62771 17.1119 7.51073 17.808Z",
    fill: "url(#paint17_radial_715_15777)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51073 17.808L5 19.2487V27H27V12.2393C25.5 12.2393 24.5 12.7313 23 14.2074L18.5 18.6356C17.5 19.6197 16.5724 19.9998 15.5724 19.5077C15.2391 19.3437 14.0345 18.5796 12.529 17.727C10.9774 16.8483 8.62771 17.1119 7.51073 17.808Z",
    fill: "url(#paint18_radial_715_15777)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51073 17.808L5 19.2487V27H27V12.2393C25.5 12.2393 24.5 12.7313 23 14.2074L18.5 18.6356C17.5 19.6197 16.5724 19.9998 15.5724 19.5077C15.2391 19.3437 14.0345 18.5796 12.529 17.727C10.9774 16.8483 8.62771 17.1119 7.51073 17.808Z",
    fill: "url(#paint19_radial_715_15777)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51073 17.808L5 19.2487V27H27V12.2393C25.5 12.2393 24.5 12.7313 23 14.2074L18.5 18.6356C17.5 19.6197 16.5724 19.9998 15.5724 19.5077C15.2391 19.3437 14.0345 18.5796 12.529 17.727C10.9774 16.8483 8.62771 17.1119 7.51073 17.808Z",
    fill: "url(#paint20_radial_715_15777)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27 26.8115V27H5V26.8114C7.56366 24.232 11.538 22.5 16 22.5C20.4619 22.5 24.4363 24.232 27 26.8115Z",
    fill: "url(#paint21_radial_715_15777)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27 26.8115V27H5V26.8114C7.56366 24.232 11.538 22.5 16 22.5C20.4619 22.5 24.4363 24.232 27 26.8115Z",
    fill: "url(#paint22_radial_715_15777)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27 26.8115V27H5V26.8114C7.56366 24.232 11.538 22.5 16 22.5C20.4619 22.5 24.4363 24.232 27 26.8115Z",
    fill: "url(#paint23_radial_715_15777)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2495 6.93358C16.5612 6.58271 16.985 6.63855 17.2561 6.93358L17.4215 7.12505C17.4788 7.18735 17.5616 7.21965 17.646 7.21255L17.94 7.12505C18.3407 7.03913 18.7049 7.33812 18.7049 7.80249V7.97742C18.7134 8.07292 18.7968 8.13766 18.883 8.17973L19.1486 8.29072C19.5329 8.47838 19.6289 8.92367 19.349 9.29739L19.2695 9.40235C19.1982 9.49878 19.2128 9.62533 19.2838 9.72201L19.3633 9.83333C19.6528 10.1896 19.4896 10.6783 19.0807 10.8491L18.852 10.9446C18.7659 10.9805 18.7322 11.0423 18.7161 11.1342L18.7002 11.4332C18.6445 11.8435 18.2801 12.0288 17.9877 11.9874L17.6394 11.8944C17.5558 11.8825 17.4518 11.9103 17.3961 11.9978L17.2705 12.1695C16.9588 12.521 16.538 12.4625 16.3258 12.257L16.094 11.9763C16.0334 11.9175 15.9568 11.8674 15.8653 11.9019L15.5147 11.9978C15.2253 12.0387 14.8846 11.8163 14.83 11.5291L14.7896 11.1135C14.7731 11.027 14.7161 10.9537 14.6363 10.9165L14.3904 10.8321C14.0206 10.6597 13.8968 10.2426 14.1091 9.89421L14.2477 9.70255C14.3033 9.61121 14.3007 9.49582 14.2409 9.40713L14.1375 9.26082C13.8449 8.84415 14.0472 8.37844 14.4808 8.23882L14.5765 8.20802C14.682 8.17404 14.784 8.08638 14.7927 7.97584L14.814 7.70749C14.8486 7.27192 15.2461 7.02199 15.6641 7.14908L15.7994 7.19021C15.9298 7.2411 16.032 7.19776 16.1032 7.12023L16.2495 6.93358Z",
    fill: "url(#paint24_linear_715_15777)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2495 6.93358C16.5612 6.58271 16.985 6.63855 17.2561 6.93358L17.4215 7.12505C17.4788 7.18735 17.5616 7.21965 17.646 7.21255L17.94 7.12505C18.3407 7.03913 18.7049 7.33812 18.7049 7.80249V7.97742C18.7134 8.07292 18.7968 8.13766 18.883 8.17973L19.1486 8.29072C19.5329 8.47838 19.6289 8.92367 19.349 9.29739L19.2695 9.40235C19.1982 9.49878 19.2128 9.62533 19.2838 9.72201L19.3633 9.83333C19.6528 10.1896 19.4896 10.6783 19.0807 10.8491L18.852 10.9446C18.7659 10.9805 18.7322 11.0423 18.7161 11.1342L18.7002 11.4332C18.6445 11.8435 18.2801 12.0288 17.9877 11.9874L17.6394 11.8944C17.5558 11.8825 17.4518 11.9103 17.3961 11.9978L17.2705 12.1695C16.9588 12.521 16.538 12.4625 16.3258 12.257L16.094 11.9763C16.0334 11.9175 15.9568 11.8674 15.8653 11.9019L15.5147 11.9978C15.2253 12.0387 14.8846 11.8163 14.83 11.5291L14.7896 11.1135C14.7731 11.027 14.7161 10.9537 14.6363 10.9165L14.3904 10.8321C14.0206 10.6597 13.8968 10.2426 14.1091 9.89421L14.2477 9.70255C14.3033 9.61121 14.3007 9.49582 14.2409 9.40713L14.1375 9.26082C13.8449 8.84415 14.0472 8.37844 14.4808 8.23882L14.5765 8.20802C14.682 8.17404 14.784 8.08638 14.7927 7.97584L14.814 7.70749C14.8486 7.27192 15.2461 7.02199 15.6641 7.14908L15.7994 7.19021C15.9298 7.2411 16.032 7.19776 16.1032 7.12023L16.2495 6.93358Z",
    fill: "url(#paint25_radial_715_15777)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2495 6.93358C16.5612 6.58271 16.985 6.63855 17.2561 6.93358L17.4215 7.12505C17.4788 7.18735 17.5616 7.21965 17.646 7.21255L17.94 7.12505C18.3407 7.03913 18.7049 7.33812 18.7049 7.80249V7.97742C18.7134 8.07292 18.7968 8.13766 18.883 8.17973L19.1486 8.29072C19.5329 8.47838 19.6289 8.92367 19.349 9.29739L19.2695 9.40235C19.1982 9.49878 19.2128 9.62533 19.2838 9.72201L19.3633 9.83333C19.6528 10.1896 19.4896 10.6783 19.0807 10.8491L18.852 10.9446C18.7659 10.9805 18.7322 11.0423 18.7161 11.1342L18.7002 11.4332C18.6445 11.8435 18.2801 12.0288 17.9877 11.9874L17.6394 11.8944C17.5558 11.8825 17.4518 11.9103 17.3961 11.9978L17.2705 12.1695C16.9588 12.521 16.538 12.4625 16.3258 12.257L16.094 11.9763C16.0334 11.9175 15.9568 11.8674 15.8653 11.9019L15.5147 11.9978C15.2253 12.0387 14.8846 11.8163 14.83 11.5291L14.7896 11.1135C14.7731 11.027 14.7161 10.9537 14.6363 10.9165L14.3904 10.8321C14.0206 10.6597 13.8968 10.2426 14.1091 9.89421L14.2477 9.70255C14.3033 9.61121 14.3007 9.49582 14.2409 9.40713L14.1375 9.26082C13.8449 8.84415 14.0472 8.37844 14.4808 8.23882L14.5765 8.20802C14.682 8.17404 14.784 8.08638 14.7927 7.97584L14.814 7.70749C14.8486 7.27192 15.2461 7.02199 15.6641 7.14908L15.7994 7.19021C15.9298 7.2411 16.032 7.19776 16.1032 7.12023L16.2495 6.93358Z",
    fill: "url(#paint26_radial_715_15777)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2495 6.93358C16.5612 6.58271 16.985 6.63855 17.2561 6.93358L17.4215 7.12505C17.4788 7.18735 17.5616 7.21965 17.646 7.21255L17.94 7.12505C18.3407 7.03913 18.7049 7.33812 18.7049 7.80249V7.97742C18.7134 8.07292 18.7968 8.13766 18.883 8.17973L19.1486 8.29072C19.5329 8.47838 19.6289 8.92367 19.349 9.29739L19.2695 9.40235C19.1982 9.49878 19.2128 9.62533 19.2838 9.72201L19.3633 9.83333C19.6528 10.1896 19.4896 10.6783 19.0807 10.8491L18.852 10.9446C18.7659 10.9805 18.7322 11.0423 18.7161 11.1342L18.7002 11.4332C18.6445 11.8435 18.2801 12.0288 17.9877 11.9874L17.6394 11.8944C17.5558 11.8825 17.4518 11.9103 17.3961 11.9978L17.2705 12.1695C16.9588 12.521 16.538 12.4625 16.3258 12.257L16.094 11.9763C16.0334 11.9175 15.9568 11.8674 15.8653 11.9019L15.5147 11.9978C15.2253 12.0387 14.8846 11.8163 14.83 11.5291L14.7896 11.1135C14.7731 11.027 14.7161 10.9537 14.6363 10.9165L14.3904 10.8321C14.0206 10.6597 13.8968 10.2426 14.1091 9.89421L14.2477 9.70255C14.3033 9.61121 14.3007 9.49582 14.2409 9.40713L14.1375 9.26082C13.8449 8.84415 14.0472 8.37844 14.4808 8.23882L14.5765 8.20802C14.682 8.17404 14.784 8.08638 14.7927 7.97584L14.814 7.70749C14.8486 7.27192 15.2461 7.02199 15.6641 7.14908L15.7994 7.19021C15.9298 7.2411 16.032 7.19776 16.1032 7.12023L16.2495 6.93358Z",
    fill: "url(#paint27_radial_715_15777)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2495 6.93358C16.5612 6.58271 16.985 6.63855 17.2561 6.93358L17.4215 7.12505C17.4788 7.18735 17.5616 7.21965 17.646 7.21255L17.94 7.12505C18.3407 7.03913 18.7049 7.33812 18.7049 7.80249V7.97742C18.7134 8.07292 18.7968 8.13766 18.883 8.17973L19.1486 8.29072C19.5329 8.47838 19.6289 8.92367 19.349 9.29739L19.2695 9.40235C19.1982 9.49878 19.2128 9.62533 19.2838 9.72201L19.3633 9.83333C19.6528 10.1896 19.4896 10.6783 19.0807 10.8491L18.852 10.9446C18.7659 10.9805 18.7322 11.0423 18.7161 11.1342L18.7002 11.4332C18.6445 11.8435 18.2801 12.0288 17.9877 11.9874L17.6394 11.8944C17.5558 11.8825 17.4518 11.9103 17.3961 11.9978L17.2705 12.1695C16.9588 12.521 16.538 12.4625 16.3258 12.257L16.094 11.9763C16.0334 11.9175 15.9568 11.8674 15.8653 11.9019L15.5147 11.9978C15.2253 12.0387 14.8846 11.8163 14.83 11.5291L14.7896 11.1135C14.7731 11.027 14.7161 10.9537 14.6363 10.9165L14.3904 10.8321C14.0206 10.6597 13.8968 10.2426 14.1091 9.89421L14.2477 9.70255C14.3033 9.61121 14.3007 9.49582 14.2409 9.40713L14.1375 9.26082C13.8449 8.84415 14.0472 8.37844 14.4808 8.23882L14.5765 8.20802C14.682 8.17404 14.784 8.08638 14.7927 7.97584L14.814 7.70749C14.8486 7.27192 15.2461 7.02199 15.6641 7.14908L15.7994 7.19021C15.9298 7.2411 16.032 7.19776 16.1032 7.12023L16.2495 6.93358Z",
    fill: "url(#paint28_radial_715_15777)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2495 6.93358C16.5612 6.58271 16.985 6.63855 17.2561 6.93358L17.4215 7.12505C17.4788 7.18735 17.5616 7.21965 17.646 7.21255L17.94 7.12505C18.3407 7.03913 18.7049 7.33812 18.7049 7.80249V7.97742C18.7134 8.07292 18.7968 8.13766 18.883 8.17973L19.1486 8.29072C19.5329 8.47838 19.6289 8.92367 19.349 9.29739L19.2695 9.40235C19.1982 9.49878 19.2128 9.62533 19.2838 9.72201L19.3633 9.83333C19.6528 10.1896 19.4896 10.6783 19.0807 10.8491L18.852 10.9446C18.7659 10.9805 18.7322 11.0423 18.7161 11.1342L18.7002 11.4332C18.6445 11.8435 18.2801 12.0288 17.9877 11.9874L17.6394 11.8944C17.5558 11.8825 17.4518 11.9103 17.3961 11.9978L17.2705 12.1695C16.9588 12.521 16.538 12.4625 16.3258 12.257L16.094 11.9763C16.0334 11.9175 15.9568 11.8674 15.8653 11.9019L15.5147 11.9978C15.2253 12.0387 14.8846 11.8163 14.83 11.5291L14.7896 11.1135C14.7731 11.027 14.7161 10.9537 14.6363 10.9165L14.3904 10.8321C14.0206 10.6597 13.8968 10.2426 14.1091 9.89421L14.2477 9.70255C14.3033 9.61121 14.3007 9.49582 14.2409 9.40713L14.1375 9.26082C13.8449 8.84415 14.0472 8.37844 14.4808 8.23882L14.5765 8.20802C14.682 8.17404 14.784 8.08638 14.7927 7.97584L14.814 7.70749C14.8486 7.27192 15.2461 7.02199 15.6641 7.14908L15.7994 7.19021C15.9298 7.2411 16.032 7.19776 16.1032 7.12023L16.2495 6.93358Z",
    fill: "url(#paint29_radial_715_15777)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2495 6.93358C16.5612 6.58271 16.985 6.63855 17.2561 6.93358L17.4215 7.12505C17.4788 7.18735 17.5616 7.21965 17.646 7.21255L17.94 7.12505C18.3407 7.03913 18.7049 7.33812 18.7049 7.80249V7.97742C18.7134 8.07292 18.7968 8.13766 18.883 8.17973L19.1486 8.29072C19.5329 8.47838 19.6289 8.92367 19.349 9.29739L19.2695 9.40235C19.1982 9.49878 19.2128 9.62533 19.2838 9.72201L19.3633 9.83333C19.6528 10.1896 19.4896 10.6783 19.0807 10.8491L18.852 10.9446C18.7659 10.9805 18.7322 11.0423 18.7161 11.1342L18.7002 11.4332C18.6445 11.8435 18.2801 12.0288 17.9877 11.9874L17.6394 11.8944C17.5558 11.8825 17.4518 11.9103 17.3961 11.9978L17.2705 12.1695C16.9588 12.521 16.538 12.4625 16.3258 12.257L16.094 11.9763C16.0334 11.9175 15.9568 11.8674 15.8653 11.9019L15.5147 11.9978C15.2253 12.0387 14.8846 11.8163 14.83 11.5291L14.7896 11.1135C14.7731 11.027 14.7161 10.9537 14.6363 10.9165L14.3904 10.8321C14.0206 10.6597 13.8968 10.2426 14.1091 9.89421L14.2477 9.70255C14.3033 9.61121 14.3007 9.49582 14.2409 9.40713L14.1375 9.26082C13.8449 8.84415 14.0472 8.37844 14.4808 8.23882L14.5765 8.20802C14.682 8.17404 14.784 8.08638 14.7927 7.97584L14.814 7.70749C14.8486 7.27192 15.2461 7.02199 15.6641 7.14908L15.7994 7.19021C15.9298 7.2411 16.032 7.19776 16.1032 7.12023L16.2495 6.93358Z",
    fill: "url(#paint30_radial_715_15777)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2495 6.93358C16.5612 6.58271 16.985 6.63855 17.2561 6.93358L17.4215 7.12505C17.4788 7.18735 17.5616 7.21965 17.646 7.21255L17.94 7.12505C18.3407 7.03913 18.7049 7.33812 18.7049 7.80249V7.97742C18.7134 8.07292 18.7968 8.13766 18.883 8.17973L19.1486 8.29072C19.5329 8.47838 19.6289 8.92367 19.349 9.29739L19.2695 9.40235C19.1982 9.49878 19.2128 9.62533 19.2838 9.72201L19.3633 9.83333C19.6528 10.1896 19.4896 10.6783 19.0807 10.8491L18.852 10.9446C18.7659 10.9805 18.7322 11.0423 18.7161 11.1342L18.7002 11.4332C18.6445 11.8435 18.2801 12.0288 17.9877 11.9874L17.6394 11.8944C17.5558 11.8825 17.4518 11.9103 17.3961 11.9978L17.2705 12.1695C16.9588 12.521 16.538 12.4625 16.3258 12.257L16.094 11.9763C16.0334 11.9175 15.9568 11.8674 15.8653 11.9019L15.5147 11.9978C15.2253 12.0387 14.8846 11.8163 14.83 11.5291L14.7896 11.1135C14.7731 11.027 14.7161 10.9537 14.6363 10.9165L14.3904 10.8321C14.0206 10.6597 13.8968 10.2426 14.1091 9.89421L14.2477 9.70255C14.3033 9.61121 14.3007 9.49582 14.2409 9.40713L14.1375 9.26082C13.8449 8.84415 14.0472 8.37844 14.4808 8.23882L14.5765 8.20802C14.682 8.17404 14.784 8.08638 14.7927 7.97584L14.814 7.70749C14.8486 7.27192 15.2461 7.02199 15.6641 7.14908L15.7994 7.19021C15.9298 7.2411 16.032 7.19776 16.1032 7.12023L16.2495 6.93358Z",
    fill: "url(#paint31_radial_715_15777)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2495 6.93358C16.5612 6.58271 16.985 6.63855 17.2561 6.93358L17.4215 7.12505C17.4788 7.18735 17.5616 7.21965 17.646 7.21255L17.94 7.12505C18.3407 7.03913 18.7049 7.33812 18.7049 7.80249V7.97742C18.7134 8.07292 18.7968 8.13766 18.883 8.17973L19.1486 8.29072C19.5329 8.47838 19.6289 8.92367 19.349 9.29739L19.2695 9.40235C19.1982 9.49878 19.2128 9.62533 19.2838 9.72201L19.3633 9.83333C19.6528 10.1896 19.4896 10.6783 19.0807 10.8491L18.852 10.9446C18.7659 10.9805 18.7322 11.0423 18.7161 11.1342L18.7002 11.4332C18.6445 11.8435 18.2801 12.0288 17.9877 11.9874L17.6394 11.8944C17.5558 11.8825 17.4518 11.9103 17.3961 11.9978L17.2705 12.1695C16.9588 12.521 16.538 12.4625 16.3258 12.257L16.094 11.9763C16.0334 11.9175 15.9568 11.8674 15.8653 11.9019L15.5147 11.9978C15.2253 12.0387 14.8846 11.8163 14.83 11.5291L14.7896 11.1135C14.7731 11.027 14.7161 10.9537 14.6363 10.9165L14.3904 10.8321C14.0206 10.6597 13.8968 10.2426 14.1091 9.89421L14.2477 9.70255C14.3033 9.61121 14.3007 9.49582 14.2409 9.40713L14.1375 9.26082C13.8449 8.84415 14.0472 8.37844 14.4808 8.23882L14.5765 8.20802C14.682 8.17404 14.784 8.08638 14.7927 7.97584L14.814 7.70749C14.8486 7.27192 15.2461 7.02199 15.6641 7.14908L15.7994 7.19021C15.9298 7.2411 16.032 7.19776 16.1032 7.12023L16.2495 6.93358Z",
    fill: "url(#paint32_radial_715_15777)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2495 6.93358C16.5612 6.58271 16.985 6.63855 17.2561 6.93358L17.4215 7.12505C17.4788 7.18735 17.5616 7.21965 17.646 7.21255L17.94 7.12505C18.3407 7.03913 18.7049 7.33812 18.7049 7.80249V7.97742C18.7134 8.07292 18.7968 8.13766 18.883 8.17973L19.1486 8.29072C19.5329 8.47838 19.6289 8.92367 19.349 9.29739L19.2695 9.40235C19.1982 9.49878 19.2128 9.62533 19.2838 9.72201L19.3633 9.83333C19.6528 10.1896 19.4896 10.6783 19.0807 10.8491L18.852 10.9446C18.7659 10.9805 18.7322 11.0423 18.7161 11.1342L18.7002 11.4332C18.6445 11.8435 18.2801 12.0288 17.9877 11.9874L17.6394 11.8944C17.5558 11.8825 17.4518 11.9103 17.3961 11.9978L17.2705 12.1695C16.9588 12.521 16.538 12.4625 16.3258 12.257L16.094 11.9763C16.0334 11.9175 15.9568 11.8674 15.8653 11.9019L15.5147 11.9978C15.2253 12.0387 14.8846 11.8163 14.83 11.5291L14.7896 11.1135C14.7731 11.027 14.7161 10.9537 14.6363 10.9165L14.3904 10.8321C14.0206 10.6597 13.8968 10.2426 14.1091 9.89421L14.2477 9.70255C14.3033 9.61121 14.3007 9.49582 14.2409 9.40713L14.1375 9.26082C13.8449 8.84415 14.0472 8.37844 14.4808 8.23882L14.5765 8.20802C14.682 8.17404 14.784 8.08638 14.7927 7.97584L14.814 7.70749C14.8486 7.27192 15.2461 7.02199 15.6641 7.14908L15.7994 7.19021C15.9298 7.2411 16.032 7.19776 16.1032 7.12023L16.2495 6.93358Z",
    fill: "url(#paint33_radial_715_15777)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7552 11.7384C17.963 11.7384 18.9421 10.7594 18.9421 9.55159C18.9421 8.34383 17.963 7.36475 16.7552 7.36475C15.5474 7.36475 14.5684 8.34383 14.5684 9.55159C14.5684 10.7594 15.5474 11.7384 16.7552 11.7384Z",
    fill: "url(#paint34_radial_715_15777)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 12.3281,
    r: 1.51562,
    fill: "url(#paint35_radial_715_15777)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.0002V10.001C6.13864 10.1664 7.07478 10.9568 7.44928 12.0129C7.47252 12.0784 7.553 12.1047 7.6112 12.0667C7.9475 11.8468 8.34942 11.7189 8.78125 11.7189C9.96347 11.7189 10.9219 12.6773 10.9219 13.8595C10.9219 15.0417 9.96347 16.0002 8.78125 16.0002H5Z",
    fill: "#DFDEFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.0002V10.001C6.13864 10.1664 7.07478 10.9568 7.44928 12.0129C7.47252 12.0784 7.553 12.1047 7.6112 12.0667C7.9475 11.8468 8.34942 11.7189 8.78125 11.7189C9.96347 11.7189 10.9219 12.6773 10.9219 13.8595C10.9219 15.0417 9.96347 16.0002 8.78125 16.0002H5Z",
    fill: "url(#paint36_linear_715_15777)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.0002V10.001C6.13864 10.1664 7.07478 10.9568 7.44928 12.0129C7.47252 12.0784 7.553 12.1047 7.6112 12.0667C7.9475 11.8468 8.34942 11.7189 8.78125 11.7189C9.96347 11.7189 10.9219 12.6773 10.9219 13.8595C10.9219 15.0417 9.96347 16.0002 8.78125 16.0002H5Z",
    fill: "url(#paint37_radial_715_15777)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.0002V10.001C6.13864 10.1664 7.07478 10.9568 7.44928 12.0129C7.47252 12.0784 7.553 12.1047 7.6112 12.0667C7.9475 11.8468 8.34942 11.7189 8.78125 11.7189C9.96347 11.7189 10.9219 12.6773 10.9219 13.8595C10.9219 15.0417 9.96347 16.0002 8.78125 16.0002H5Z",
    fill: "url(#paint38_radial_715_15777)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_715_15777",
    x: 5,
    y: 12.2393,
    width: 22,
    height: 14.8607,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.352941 0 0 0 0 0.690196 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_15777",
    x1: 16,
    y1: 5,
    x2: 16,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614765,
    stopColor: "#85D6F5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.3117 10.6875) rotate(18.4331) scale(1.97661)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.209985,
    stopColor: "#D4D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754934,
    stopColor: "#DDDCFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.7336 12.6094) rotate(-50.9342) scale(3.09915 1.44237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.457026,
    stopColor: "#EFEFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.0005 12.3126) rotate(-128.32) scale(2.46954 5.0951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.581265,
    stopColor: "#DEDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D9FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.7818 12.8751) rotate(-42.7094) scale(1.65861 2.55667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.564164,
    stopColor: "#EFEFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728168,
    stopColor: "#EFEFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.8583 12.7781) rotate(152.354) scale(6.19123)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.400983,
    stopColor: "#EEEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_715_15777",
    x1: 3.5,
    y1: 2,
    x2: 3.5,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D38E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272321,
    stopColor: "#EFA570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79771,
    stopColor: "#EFA570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D38E57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_715_15777",
    x1: 4.0909,
    y1: 28.1055,
    x2: 3.86744,
    y2: 27.8626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB7734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB7734",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_715_15777",
    x1: 10.5711,
    y1: 28.9993,
    x2: 31.6343,
    y2: 28.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E69F70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3895C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_715_15777",
    x1: 16,
    y1: 30.5625,
    x2: 16,
    y2: 29.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D47F6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D47F6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_715_15777",
    x1: 27.8684,
    y1: 27.7544,
    x2: 27.6404,
    y2: 27.9825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C67331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C67331",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_715_15777",
    x1: 28.5,
    y1: 2,
    x2: 28.5,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA7C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0966B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_715_15777",
    x1: 28.1563,
    y1: 3.75,
    x2: 28.293,
    y2: 3.89063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2712E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2712E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_715_15777",
    x1: 27.3701,
    y1: 4.37184,
    x2: 3.60596,
    y2: 4.37184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D28459"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_715_15777",
    x1: 16,
    y1: 5,
    x2: 16,
    y2: 4.67187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC8159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC8159",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_715_15777",
    x1: 3.91116,
    y1: 4.13497,
    x2: 4.45584,
    y2: 3.63219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C77731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C77731",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 24.1035) rotate(-90) scale(8.72958 21.4715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DAC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35BD69"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5625 16.3125) rotate(50.3558) scale(8.52249 5.18342)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DC277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DC277",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27 12.2393) rotate(90) scale(12.6982 5.0046)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BCC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BCC74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18 18.3125) rotate(110.45) scale(3.93551 2.5757)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.350226,
    stopColor: "#4CA876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CA876",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5 28.125) rotate(-49.844) scale(5.2336 7.8004)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#399E60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#399E60",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 27) rotate(-90) scale(4.04422 11.7897)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FD86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FD660"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.39028 28.2655) rotate(-31.3955) scale(10.3168 13.9517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79C56C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C56C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.5643 28.395) rotate(-133.877) scale(9.34232 9.40426)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93EB81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93EB81",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_715_15777",
    x1: 18.4535,
    y1: 7.65336,
    x2: 15.3289,
    y2: 11.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67639"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.2812 6.95523) rotate(138.155) scale(0.769184 0.678659)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.300161,
    stopColor: "#FFA13A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA13A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.2799 6.71241) rotate(67.8105) scale(1.22282 1.07891)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.300161,
    stopColor: "#FF942A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF942A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.564 7.85322) rotate(-164.745) scale(0.487556 0.675085)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.300161,
    stopColor: "#FFA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA13D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5475 8.56306) rotate(154.195) scale(0.86446 0.638467)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.300161,
    stopColor: "#FFA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA13D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.7357 10.0255) rotate(-173.379) scale(0.964289 0.54341)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.300161,
    stopColor: "#FFA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA13D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8719 11.1459) rotate(-43.9639) scale(0.874688 0.84266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0762A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.8181 10.9406) rotate(-127.747) scale(0.670579 0.646024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0762A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.903 8.67424) rotate(25.2777) scale(0.68097 0.82305)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0851D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0851D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.9678 12.117) rotate(-142.487) scale(0.793939 0.749012)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336586,
    stopColor: "#E3745B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3745B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.9962 8.28466) rotate(117.739) scale(3.90225 4.8189)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17178,
    stopColor: "#FFCB38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA21C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5AE1B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.67184 12.1094) rotate(-115.017) scale(1.55184)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108272,
    stopColor: "#EBEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_715_15777",
    x1: 7.06247,
    y1: 16.0002,
    x2: 7.06247,
    y2: 15.1252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFC9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5625 13.3127) rotate(151.736) scale(3.29965 2.77018)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_715_15777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.87497 10.6877) rotate(121.861) scale(2.72323 2.20759)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222069,
    stopColor: "#F4F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFramedPicture);
export default __webpack_public_path__ + "static/media/FramedPicture.dde60d0bc96dbdba09ca624c23d3fa85.svg";
export { ForwardRef as ReactComponent };